import React from 'react';
import { LiveStreamWidget } from '../widget/LiveStreamWidget';
import config from '../config';

const LiveStreamTest = () => {
  const widgetConfig = {
    companyId: process.env.REACT_APP_COMPANY_ID,
    apiKey: process.env.REACT_APP_API_KEY,
    backendUrl: config.backendUrl
  };

  return (
    <div className="page-wrapper">
      <div className="stream-test-container">
        <h1>Live Stream Test Page</h1>
        <LiveStreamWidget config={widgetConfig} />
      </div>
    </div>
  );
};

export default LiveStreamTest; 